import GoogleAuthVerify from "@panel/auth/login/google-auth";
import Login from "@panel/auth/login";
import TwoFactorAuth from "@panel/auth/login/two-factor-auth";
import themeConfig from "@src/configs/theme-config";
import SuperadminLogin from "@src/views/superadmin/auth/login";

const AuthenticationRoutes = [
    {
        path   : "/login",
        element: <Login />,
        meta   : {
            layout     : "blank",
            restricted : true,
            title      : `${themeConfig.app.name} Login`,
            publicRoute: true
        }
    },
    {
        path   : "/superadmin",
        element: <SuperadminLogin />,
        meta   : {
            layout     : "blank",
            restricted : true,
            title      : "CSNext Login | Superadmin",
            publicRoute: true
        }
    },
    {
        path   : "/auth/verify/google",
        element: <GoogleAuthVerify />,
        meta   : {
            layout     : "blank",
            restricted : true,
            title      : `${themeConfig.app.name} Login`,
            publicRoute: true
        }
    },
    {
        path   : "/verify/two-factor-auth",
        element: <TwoFactorAuth />,
        meta   : {
            layout     : "blank",
            restricted : true,
            title      : "Two Factor Authentication",
            publicRoute: true
        }
    }
    // {
    //     path   : "/forgot-password",
    //     element: <ForgotPassword />,
    //     meta   : {
    //         layout     : "blank",
    //         publicRoute: true,
    //         restricted : true,
    //         title      : "Forgot Password"
    //     }
    // },
    // /**
    //  * RESET_PASSWORD
    //  */
    // {
    //     path   : "/password/reset/:token",
    //     element: <ResetPassword />,
    //     meta   : {
    //         title      : "Reset Password",
    //         layout     : "blank",
    //         publicRoute: true,
    //         restricted : false
    //     }
    // }
];

export default AuthenticationRoutes;
